/** @jsxImportSource @emotion/react */

import type { ComponentPropsWithRef, ElementType } from "react";
import { forwardRef } from "react";
import { dotBadgeCSS, variantMap } from "./DotBadge.css";
import type { DotBadgeComponent, DotBadgeProps } from "./DotBadge.types";

export const DotBadge: DotBadgeComponent = forwardRef(function ClayDotBadge<E extends ElementType>(
  { variant, as, className, native, size = "small", sx, type = "default" }: DotBadgeProps<E>,
  ref: ComponentPropsWithRef<E>["ref"],
) {
  const Element = as || "span";

  return (
    <Element
      ref={ref}
      className={className}
      {...native}
      style={{
        ...variantMap.variant[variant],
        ...variantMap.size[size],
        ...variantMap.type[type],
        ...native?.style,
      }}
      css={[dotBadgeCSS, sx]}
    />
  );
});
